import React from 'react';

interface MoodEnergyProps {
  mood?: string;
  energy?: string;
  onMoodChange: (mood: string) => void;
  onEnergyChange: (energy: string) => void;
  disabled?: boolean;
}

export const MoodEnergySelector: React.FC<MoodEnergyProps> = ({ 
  mood, 
  energy, 
  onMoodChange, 
  onEnergyChange, 
  disabled = false 
}) => {
  const moodOptions = [
    { value: 'excellent', label: '😊 Excellent', color: 'text-green-600' },
    { value: 'good', label: '🙂 Good', color: 'text-blue-600' },
    { value: 'okay', label: '😐 Okay', color: 'text-yellow-600' },
    { value: 'challenging', label: '😕 Challenging', color: 'text-orange-600' },
    { value: 'difficult', label: '😞 Difficult', color: 'text-red-600' }
  ];

  const energyOptions = [
    { value: 'high', label: '⚡ High', color: 'text-green-600' },
    { value: 'medium', label: '🔋 Medium', color: 'text-yellow-600' },
    { value: 'low', label: '🪫 Low', color: 'text-red-600' }
  ];

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          How is your mood?
        </label>
        <select
          value={mood || ''}
          onChange={(e) => onMoodChange(e.target.value)}
          disabled={disabled}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Select mood...</option>
          {moodOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          How is your energy?
        </label>
        <select
          value={energy || ''}
          onChange={(e) => onEnergyChange(e.target.value)}
          disabled={disabled}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Select energy...</option>
          {energyOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};